function item_scroller() {
    let element = document.querySelectorAll('.recruit_journey > ol');
    // console.log(element.length);
  
    if( element.length ) {
  
        element.forEach( element => {
  
            if( ! element.parentNode.querySelector('.scroll_btns') ) {
  
                // console.log(element);
                // console.log(! element.parentNode.querySelector('.scroll_btns'));
                
                let button = document.createElement('div'),
                    buttons = document.createElement('div'),
                    svg_icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><path d="M22.71,49.04c-.25,0-.5-.1-.68-.31-.33-.38-.29-.95.08-1.28l19.93-17.45L22.11,12.55c-.38-.33-.41-.9-.08-1.28.33-.38.9-.42,1.28-.09l20.71,18.13c.2.17.31.42.31.68s-.11.51-.31.68l-20.71,18.13c-.17.15-.38.22-.6.22Z"/></svg>';                  scroll_distance = 400;
  
                    button.insertAdjacentHTML( 'beforeend', svg_icon );
                    buttons.classList.add('scroll_btns');
                    buttons.append(button);
                    buttons.append(button.cloneNode(true));
  
                if( element.scrollWidth > element.clientWidth ) {
                    element.after(buttons);
                    
                    buttons.querySelectorAll('div').forEach( btn => {
                        btn.addEventListener('click', () => {
                            if( btn == btn.parentNode.firstElementChild ) {
                                element.scrollLeft -= scroll_distance;
                            } else {
                                element.scrollLeft += scroll_distance;
                            }
                        });
                    });
                } else {
                    element.classList.add('no_scroll');
                }
                
            }
            
        });
    }
    
  }
  
  jQuery(document).ready(function() {
    item_scroller();
  });